import React from "react";
import {
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  EditProps,
  AutocompleteArrayInput,
  ReferenceArrayInput,
  useEditController,
  Toolbar,
  SaveButton,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { cloneDeep } from "lodash";
import PermissionLoading from "../../components/PermissionLoading";
import EditWrapper from "../../components/EditWrapper";

const AssignmentEdit = (props: EditProps) => {
  const { id } = props;
  const { record, loading } = useEditController(props);

  const breadcrumb = [
    {
      title: "Bus Services",
      link: `/assignments`,
    },
    {
      title: id,
      link: ``,
    },
  ];

  const AssignmentEditToolbar = (props: any) => (
    <Toolbar {...props}>
      <SaveButton redirect="show" label="Assign" />
    </Toolbar>
  );

  const formatRecord = (res: any) => {
    if (res) {
      if (res.backupDrivers) {
        const backupDriverClone = cloneDeep(res.backupDrivers);
        const backupDriversIds = backupDriverClone.map((item: any) => {
          return item.id;
        });
        res.backupDriverIds = backupDriversIds;
      }

      if (res.backupVehicles) {
        const backupVehicleClone = cloneDeep(res.backupVehicles);
        const backupVehiclesIds = backupVehicleClone.map((item: any) => {
          return item.id;
        });
        res.backupVehicleIds = backupVehiclesIds;
      }

      if (res.backupBusAssistants) {
        const backupBusAssistantClone = cloneDeep(res.backupBusAssistants);
        const backupBusAssistantsIds = backupBusAssistantClone.map(
          (item: any) => {
            return item.id;
          },
        );
        res.backupBusAssistantIds = backupBusAssistantsIds;
      }
    }
    return res;
  };

  if (loading) {
    return <PermissionLoading />;
  }

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        customFieldName="routeName"
        {...props}
      >
        <SimpleForm
          record={formatRecord(record)}
          toolbar={<AssignmentEditToolbar />}
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Main Operations</Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select Driver"
                source="driverId"
                reference="drivers"
                filterToQuery={(searchText: any) => {
                  if (searchText !== "") return { search: searchText };
                }}
                allowEmpty
              >
                <AutocompleteInput
                  optionText={(choice: any) =>
                    `${choice.fullName} (${choice.subcontractorName})`
                  }
                />
              </ReferenceInput>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select Bus Assistant"
                source="busAssistantId"
                reference="busAssistants"
                filterToQuery={(searchText: any) => {
                  if (searchText !== "") return { search: searchText };
                }}
                allowEmpty
              >
                <AutocompleteInput
                  optionText={(choice: any) =>
                    `${choice.fullName} (${choice.subcontractorName})`
                  }
                />
              </ReferenceInput>
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <ReferenceInput
                label="Select Vehicle"
                source="vehicleId"
                reference="vehicles"
                filterToQuery={(searchText: any) => {
                  if (searchText !== "") return { search: searchText };
                }}
                allowEmpty
              >
                <AutocompleteInput optionText="plateNumber" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Backup</Typography>
            </Grid>

            <Grid item xs={4}>
              <ReferenceArrayInput
                label="Select Backup Drivers"
                source="backupDriverIds"
                reference="drivers"
                filterToQuery={(searchText: any) => {
                  if (searchText !== "") return { search: searchText };
                }}
              >
                <AutocompleteArrayInput
                  optionText={(choice: any) =>
                    `${choice?.fullName} (${choice?.subcontractorName})`
                  }
                />
              </ReferenceArrayInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <ReferenceArrayInput
                label="Select Backup Bus Assistants"
                source="backupBusAssistantIds"
                reference="busAssistants"
                filterToQuery={(searchText: any) => {
                  if (searchText !== "") return { search: searchText };
                }}
              >
                <AutocompleteArrayInput
                  optionText={(choice: any) =>
                    `${choice?.fullName} (${choice?.subcontractorName})`
                  }
                />
              </ReferenceArrayInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <ReferenceArrayInput
                label="Select Backup Vehicles"
                source="backupVehicleIds"
                reference="vehicles"
                filterToQuery={(searchText: any) => {
                  if (searchText !== "") return { search: searchText };
                }}
              >
                <AutocompleteArrayInput optionText="plateNumber" />
              </ReferenceArrayInput>
            </Grid>
            <Grid item xs={8}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default AssignmentEdit;
